module.exports = __webpack_public_path__ + "assets/img/audio_play.1c15a1d5.png";